/** Phase 18 — customerDebts lesen. */

import { listAggregateCustomerDebts } from '../infrastructure/storage/domainAggregateStore';
import { listEntityCustomerDebts } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'customerDebts',
  listAggregate: listAggregateCustomerDebts,
  listEntity: listEntityCustomerDebts,
  idKeys: ['id', 'customerId']
});

export const readCustomerDebtsFromMergedBlob = source.readFromMergedBlob;
export const readCustomerDebtsFromBestSource = source.readFromBestSource;
export const refreshCustomerDebtsReadCache = source.refreshReadCache;
export const getCachedCustomerDebtsRead = source.getCachedRead;
export const clearCustomerDebtsReadCache = source.clearReadCache;
export const readCustomerDebtsSyncForBusiness = source.readSyncForBusiness;
